/**
 * pf
 */
export default
    {
        path: "/pf",
        component: () => import('@/views/MainContent/MainContent'),
        children: [
            {
                path: 'workspace/homepage',
                name: 'workspace/homepage',
                component: () => import('@/views/pf/HomePage'),
                meta: {
                    keepAlive: true,
                    title:'工作台'
                }
            },
            {
                path: 'notice/list',
                name: 'NoticeList',
                component: () => import('@/views/pf/notice/NoticeList'),
                meta: {
                    keepAlive: true,
                    title:'公告管理'
                }
            },
            {
                path: 'user/list',
                name: 'UserList',
                component: () => import('@/views/pf/user/List'),
                meta: {
                    keepAlive: true,
                    title:'员工列表'
                }
            },
            {
                path: 'user/roleList',
                name: 'RoleList',
                component: () => import('@/views/pf/user/RoleList'),
                meta: {
                    keepAlive: true,
                    title:'角色管理'
                }
            },
            {
                path: 'leader/list',
                name: 'leaderList',
                component: () => import('@/views/pf/leader/List'),
                meta: {
                    keepAlive: true,
                    title:'海外负责人管理'
                }
            },
            {
                path: 'leader/service-list',
                name: 'leaderServiceList',
                component: () => import('@/views/pf/leader/ServiceList'),
                meta: {
                    keepAlive: true,
                    title:'刷手列表'
                }
            },
            {
                path: 'business/rate',
                name: 'rateList',
                component: () => import('@/views/pf/business/company-rate/RateList'),
                meta: {
                    keepAlive: true,
                    title:'商家汇率'
                }
            },
            {
                path: 'business/list',
                name: 'sjlbList',
                component: () => import('@/views/pf/business/list/index'),
                meta: {
                    keepAlive: true,
                    title:'商家列表'
                }
            },
            {
                path: 'business/examine',
                name: 'examineList',
                component: () => import('@/views/pf/business/examine/index'),
                meta: {
                    keepAlive: true,
                    title:'商家认证审核'
                }
            },
            {
                path: 'acct/service-settlement',
                name: 'ServiceSettlement',
                component: () => import('@/views/pf/acct/tags'),
                meta: {
                    keepAlive: true,
                    title:'刷手佣金结算'
                }
            },
            {
                path: 'acct/bill-flow',
                name: 'billFlow',
                component: () => import('@/views/pf/acct/bill-flow'),
                meta: {
                    keepAlive: true,
                    title:'收支明细'
                }
            },
            {
                path: 'acct/charge-list',
                name: 'chargeList',
                component: () => import('@/views/pf/acct/charge-list'),
                meta: {
                    keepAlive: true,
                    title:'充值管理'
                }
            },
            {
                path: 'setting/fee-standard',
                name: 'feeStandard',
                component: () => import('@/views/pf/setting/Fee-standard'),
                meta: {
                    keepAlive: true,
                    title:'收费付费标准'
                }
            },
            {
                path: 'setting/receive-order',
                name: 'receiveOrder',
                component: () => import('@/views/pf/setting/Receive-order'),
                meta: {
                    keepAlive: true,
                    title:'接单管理'
                }
            } ,
            {
                path: 'setting/exchange-rate',
                name: 'Exchange-rate',
                component: () => import('@/views/pf/setting/Exchange-rate'),
                meta: {
                    keepAlive: true,
                    title:'汇率管理'
                }
            } ,
            {
                path: 'task/complaint',
                name: 'Complaint',
                component: () => import('@/views/pf/task/ComplaintTags'),
                meta: {
                    keepAlive: true,
                    title:'投诉管理'
                }
            },
            {
                path: 'task/list',
                name: 'TaskTags',
                component: () => import('@/views/pf/task/TaskTags'),
                meta: {
                    keepAlive: true,
                    title:'任务管理'
                }
            }



        ]

    }


// WEBPACK FOOTER //
// ./src/router/pf.js